export default {
    user: {},
    geolocation: null,
    isLogged: false,
    logged_at: null,
    error: false,
    invalid: false,
    errorMessage: '',
    roles: [],
}
